import { buildPanelItem } from "../helpers/buildPanelItem";
import { Label } from "../components/Label";

export const imagePanel = [
  buildPanelItem(
    "1",
    Label({ label: "md5", type: "string" }),
    "According to our privacy-first approach, no personal information is stored within our domain. However, we do keep the MD5 hash of the image that we analyzed so that later we can properly audit the transaction in case the partner asks us to do so and provides us with the image as an input for the audit.",
  ),
  buildPanelItem(
    "2",
    Label({ label: "base64", type: "string" }),
    "The face image that was captured by the user for authentication. This is a personal information that is sent to the partner via webhook and is not stored within our domain.",
  ),
];
